module.exports = function(app) {
    var receiptJson = require("./getReceiptBoxItems");
    app.controller("pages.spending.receipts", ["$scope", "session","services", "storage","coremetrics","spendingAccountsService","$cookies","invisibleForm",'educationalMaterialService', '$window','$q','spaUtil','$state','$filter',
        function( $scope, session, services, storage, coremetrics, spendingAccountsService, $cookies, invisibleForm, educationalMaterialService, $window,$q,spaUtil,$state,$filter) {

            $scope.viewState = 'loading';
            var receiptBoxListWidget = null,
                newClaimWidget,
                newReceiptWidget,
                receiptBoxData = [],
                promiseArray = [],

                //currentFromServiceDate = refineUtil.getFromDateDefaultRange(),
               // currentToServiceDate = new Date(),
              //  getFromServiceDate = refineUtil.getFromSubmitDateDefaultRange(),
               // getToServiceDate = refineUtil.getToSubmitDateDefaultRange(),
                categoryListObj = {},
                statusListObj = {},
                amountTextMinimum = null,
                amountTextMaximum = null,
                currentMinimumValueOnChange = 0,
                currentMaximumValueOnChange = 0,
                listData = null,
                memberData = session.data.memberInfo;
            $scope.viewReceiptArray=[];
            $scope.ff=[];

           /* var formatDate =function(value) {
                var dateIn = value;
                var yyyy = dateIn.getFullYear();
                var mm = dateIn.getMonth() + 1; // getMonth() is zero-based
                var dd = dateIn.getDate();
                var preParse = String(10000 * yyyy + 100 * mm + dd); // Leading zeros for mm and dd
                var yearHolder = preParse.substring(0, 4);
                var monthHolder = preParse.substring(4, 6);
                var dayDateHolder = preParse.substring(6, 8);
                preParse = monthHolder + "/" + dayDateHolder + "/" + yearHolder;
                return preParse;
            };*/

            var buildReceiptsView =function(dateRange){
                dateRange = JSON.parse(dateRange || createDateRange(365));
                fromDate = dateRange.startDate.substr(4,2) + '/' + dateRange.startDate.substr(6,2) + '/' + dateRange.startDate.substr(0,4);
                toDate =dateRange.endDate.substr(4,2) + '/' + dateRange.endDate.substr(6,2) + '/' + dateRange.endDate.substr(0,4);


                var thisUMI = memberData.umi+'0';
                var spendingAccountClient =spendingAccountsService.spendingAccountClients();
                if(spendingAccountClient && spendingAccountClient.length>0){
                    spendingAccountClient.forEach(function(client){

                        var getReceiptsPayload = {
                            "getAllShoeboxItemsRequest": {
                                "participantCode": thisUMI,
                                "groupCode": client,
                                "clientName": "Mobile",
                                "userType": "EE",
                                "pagination": {
                                    "pageSize": "4",
                                    "startAfterSequenceId": "4"
                                },
                                "searchCriteria": {
                                    "status": "true",
                                    "startDate": fromDate,
                                    "endDate": toDate
                                }
                            }
                        };

                        // queue up the calls for receipts, for each client
                        listData = null;
                        promiseArray = [];


                        listData = services.rbsmbl.getAllShoeboxItems().fetch(getReceiptsPayload);
                        listData.then(function(response) {
                                $scope.viewState="success";
                                response = receiptJson;
                                var thisCall = response.data.GetAllShoeboxItemsResponseMessage.payload.shoeboxItems;
                                if (thisCall) {
                                    for (var i = 0; i < thisCall.length; i++) {
                                        thisCall[i].umi = thisUMI;
                                        thisCall[i].clientNumber = client;
                                        $scope.ff.push(thisCall[i]);
                                    }
                                }
                            },
                            function(error) {

                                console.log("we had a problem with this client's receipts call", error);
                            });

                        // push these calls into an array
                        promiseArray.push(listData);

                    });


                    // after client receipt calls have been made
                    $q.all(promiseArray).then(function(results) {
                        $scope.viewState="success";
                        var newReceiptArray=[];

                        for (var i = 0; i < $scope.ff.length; i++) {
                           // $scope.ff[i].umi = thisUMI;
                            //$scope.ff[i].clientNumber = client;
                            newReceiptArray.push($scope.ff[i]);
                        }

                        if (newReceiptArray.length > 0) {

                        } else {
                            console.log("no receipts are found");

                        }

                        storage.set("receiptCount", newReceiptArray.length);
                        console.log("receiptCount", newReceiptArray.length);
                        console.log("newReceiptArray", newReceiptArray);

                        // don't sort unless we have more than one receipt
                        if (newReceiptArray.length > 1) {
                            newReceiptArray.sort(spaUtil.sortReceiptsByServiceDateDescending);
                            console.log("newReceiptArraySorted", newReceiptArray);
                        }

                        // if a receipt selection path is in effect, we want only unused receipts to be in the list.
                        var useOrbReceiptCheck = storage.get("receiptUsePath");

                        //// temporary hack for handling two bootstraps.  setting path to receipt required
                        //var locationHash = (location.hash.substr(1).indexOf('receiptrequired') > -1) ? true : false;
                        //console.log("qq",locationHash);
                        //if (locationHash) {
                        //    hmStorage.set("receiptUsePath", "newReceiptRequired");
                        //}

                        if (useOrbReceiptCheck) {
                            var unusedArray = [];
                            for (var i = 0; i < newReceiptArray.length; i++) {
                                if (newReceiptArray[i].status === "Unused") {
                                    unusedArray.push(newReceiptArray[i]);
                                }
                            }
                            newReceiptArray = unusedArray;
                            // update the count to reflect only unused receipts
                            storage.set("receiptCount", newReceiptArray.length);
                            console.log("receiptCount", newReceiptArray.length);
                        }

                        if (storage.get("receiptCount") === 0) {
                            var whichUsePath = storage.get('receiptUsePath');
                            if (whichUsePath) {
                                /*domClass.add(query('.nav-link', 'data-receipts')[0], 'no-refine');
                                domStyle.set(query('.mobile-refine-container')[0], "display", "none");
                                domClass.remove('noReceiptsUnusedNode', 'display-none');
                                domClass.add('noReceiptsNode', 'display-none');
                                query("#selectOrbHeader").addClass("display-none");
                                query(".ribbon-wrapper, .ribbon-bottom, .content-loader").addClass("display-none");*/
                            }
                        } else {
                           // domClass.add('noReceiptsUnusedNode', 'display-none');
                            if (whichUsePath) {
                                //query("#selectOrbHeader").removeClass("display-none");
                            }
                        }
                        loadData(newReceiptArray);
                       // receiptBoxListWidget.listUpdate();
                        //buildReceiptsRefine(newReceiptArray);

                    });
                };
            };

            var loadData=function(data){
                var receiptArray=data || [];
                if(receiptArray){
                    storage.set("selectedReceipt", null);
                    $scope.useReceipt=function(index){
                        storage.set("selectedReceipt", receiptArray[index]);
                        var receiptPath = storage.get("receiptUsePath");
                        if (receiptPath === "receiptRequired") {
                            $state.go("member/spending/receipts");
                        }
                        else if (receiptPath === "newReceiptRequired") {
                            //window.location.href="/member/spending/receiptRequired";
                            $state.go("spending.newReceipt");

                        }
                        else {
                            $state.go("spending.newClaims");
                        }
                    };

                    $scope.editReceipt=function(index){
                        storage.set("selectedReceipt", receiptArray[index]);
                        storage.set("receiptUsePath", "editReceipt");
                        $state.go("/member/newReceipt");
                    };

                    var displayInfo = {};
                    for (var i = 0; i < receiptArray.length; i++) {
                        var thisRow = receiptArray[i];
                        //                    console.log("thisRow",thisRow);
                        var thisCategoryIcon;
                        if (thisRow.category === "Medical" || thisRow.category === "Medical-OTC" || thisRow.category === "Medical-Preventative") {
                            thisCategoryIcon = "icon-provider";
                        } else if (thisRow.category === "Dental") {
                            thisCategoryIcon = "icon-dental";
                        } else if (thisRow.category === "Vision") {
                            thisCategoryIcon = "icon-vision";
                        } else {
                            thisCategoryIcon = "icon-cash";
                        }


                        displayInfo = {
                            "submitDate": thisRow.uploadDateTime,
                            "provider": thisRow.provider,
                            "amount": parseFloat(thisRow.amount),
                            "receiptCategory": thisRow.category,
                            "receiptIcon": thisCategoryIcon,
                            "receiptType": thisRow.status,
                            "serviceDate": thisRow.serviceDate,
                            "noteReceipt": thisRow.note,
                            "receiptName": thisRow.shoeboxImages[0].name,
                            "usedNode": "",
                            "unusedNode": "",
                            "receiptID": "receipt" + thisRow.ID,
                            "hideDelete": "",
                            "hideEdit": "",
                            "hideView": ""
                        };

                        if (thisRow.status === "Used") {
                            displayInfo.unusedNode = "ng-hide";
                            displayInfo.hideDelete = "ng-hide";
                            displayInfo.hideEdit = "ng-hide";
                        } else {
                            displayInfo.usedNode = "ng-hide";
                        }
                        $scope.viewReceiptArray.push(displayInfo);

                    }
                }
            };

            var setUpPagination =function(){
                $scope.sidebar.filtersChanged = function() {
                    $scope.pagination.page = 1;
                };
                $scope.$watch('pagination.page', function(v) {
                    storage.set('receiptsRefinePage', v);
                });
                $scope.$on('prevClick', function() {
                    var prevPage = $scope.pagination.page;
                    prevPage -= 1;
                    coremetrics.pageviewTag("MEMBER:RECEIPTS " + prevPage, "MEMBER:SPENDING");
                    coremetrics.elementTag("PREV:RECEIPTS", "MEMBER:SPENDING");
                });

                $scope.$on('nextClick', function() {
                    var nextPage = $scope.pagination.page;
                    nextPage += 1;
                    coremetrics.pageviewTag("MEMBER:RECEIPTS" + nextPage, "MEMBER:SPENDING");
                });

                $scope.$on('goToPageClick', function() {
                    coremetrics.elementTag("SELECT PAGE NUMBER:RECEIPTS", "MEMBER:SPENDING");
                });

            };

            var buildRefineContent =function(){
                var createDateRange = function(startDaysAgo, endDaysAgo) {
                    startDate = $filter('date')(new Date() - startDaysAgo*60*60*24*1000, 'yyyyMMdd')
                    endDate = endDaysAgo
                        ? $filter('date')(new Date() - endDaysAgo*60*60*24*1000, 'yyyyMMdd')
                        : $filter('date')(new Date(), 'yyyyMMdd');
                    return JSON.stringify({ startDate: startDate, endDate: endDate });
                };
                $scope.sidebar.receiptsDateRange = createDateRange(365);
                $scope.sidebar.receiptsDateRangeOptions = [
                    { label: "Last 12 Months", value: createDateRange(365) },
                    { label: "Last 6 Months", value: createDateRange(183) },
                    { label: "Last 90 Days", value: createDateRange(90) },
                    { label: "Last 60 Days", value: createDateRange(60) },
                    { label: "Last 30 Days", value: createDateRange(30) }

                ];
                //filter for date range
                $scope.$watch('sidebar.receiptsDateRange', function(r) {
                    for (var i = 0, options = $scope.sidebar.receiptsDateRangeOptions, value; i < options.length; i++) {
                        value = options[i].value;

                        if (value === r) {
                            if (i < 5) {
                                options.splice(5, 1);
                            }
                        }
                    }
                    buildReceiptsView($scope.sidebar.receiptsDateRange);
                });


                //filter on  receipts category





            };


            buildRefineContent();
            setUpPagination();






            $scope.submitReceipt = function() {
                sessionStorage.incomingUrl = "receipts";
                $window.location = '/member/spending/clientListSelection';
            };
            $scope.submitClaims = function() {
                sessionStorage.incomingUrl = "claim";
                $window.location = '/member/spending/clientListSelection';
            };

        }])
};